module.exports = __webpack_public_path__ + "static/img/9.6602160.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/9.png
// module id = 7vsR
// module chunks = 0